<template>
  <div class="project-operation">
    <FadeInBox>
      <div class="content-center">
        <div class="module-header">
          <div class="module-title">形成 “轻资产、高效率” 的项目运营体系</div>
        </div>
        <div class="module-body">
          <div class="content-item">
            <img class="content-item-icon" src="@/assets/img/cooperation/ProjectOperation/item_icon1.png">
            <span class="content-item-text">保留传统企业组织形式与主体身份特性，兼顾企业主 / 个人的经营自主性</span>
          </div>
          <div class="content-item">
            <img class="content-item-icon" src="@/assets/img/cooperation/ProjectOperation/item_icon2.png">
            <span class="content-item-text">聚合平台生态资源（资质、资金、人才、技术、供应链等），突破行业门槛高、项目落地难等痛点</span>
          </div>
        </div>
      </div>
    </FadeInBox>
  </div>
</template>

<script>
import FadeInBox from './FadeInBox.vue';

export default {
  components: { FadeInBox },
};
</script>

<style lang="less" scoped>
.project-operation {
  padding-top: 64px;

  .content-center {
    padding-bottom: 108px;
    background-image: url('@/assets/img/cooperation/ProjectOperation/background.png');
    background-position: right bottom;
    background-repeat: no-repeat;
    .module-body {
      width: 714px;
      margin-top: 102px;

      .content-item {
        margin-top: 59px;
        padding-left: 40px;
        position: relative;
        .content-item-icon {
          width: 28px;
          height: 28px;
          position: absolute;
          left: 0;
          top: 0;
        }
        .content-item-text {
          font-family: @font-medium;
          font-size: 18px;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
